import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FaBars, FaTimes, FaEnvelope } from 'react-icons/fa';
import NotificationBell from '../NotificationBell';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Çıkış yapılırken hata:', error);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="bg-[#2B4EE7] text-white">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center group relative">
            <div className="flex items-center relative">
              <span className="text-2xl font-bold text-white relative group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-blue-400 group-hover:via-purple-400 group-hover:to-pink-400 transition-all duration-300">
                EXCEL
              </span>
              <span className="mx-1 text-white group-hover:text-blue-200 transition-colors duration-300">|</span>
              <span className="text-2xl font-bold text-white relative group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-pink-400 group-hover:via-purple-400 group-hover:to-blue-400 transition-all duration-300">
                VADİSİ
              </span>
            </div>
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 group-hover:w-full transition-all duration-500"></span>
          </Link>

          {/* Ana Menü */}
          <div className="hidden lg:flex items-center space-x-6">
            <Link 
              to="/blog" 
              className="text-base text-white font-medium relative group"
            >
              <span>BLOG</span>
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 group-hover:w-full transition-all duration-300"></span>
            </Link>

            <Link 
              to="/automation" 
              className="text-base text-white font-medium relative group"
            >
              <span>OTOMASYONLAR</span>
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-green-500 via-teal-500 to-blue-500 group-hover:w-full transition-all duration-300"></span>
            </Link>

            <Link 
              to="/qa" 
              className="text-base text-white font-medium relative group"
            >
              <span>SORU & CEVAP</span>
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 group-hover:w-full transition-all duration-300"></span>
            </Link>

            {user && (
              <>
                <Link 
                  to="/requests/new" 
                  className="text-base text-white font-medium relative group"
                >
                  <span>ÖZEL İSTEK</span>
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-purple-500 via-violet-500 to-fuchsia-500 group-hover:w-full transition-all duration-300"></span>
                </Link>

                <Link 
                  to="/requests" 
                  className="text-base text-white font-medium relative group"
                >
                  <span>İSTEKLERİM</span>
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-500 via-cyan-500 to-teal-500 group-hover:w-full transition-all duration-300"></span>
                </Link>
              </>
            )}
          </div>

          {/* Sağ Taraf - Kullanıcı Menüsü */}
          <div className="hidden lg:flex items-center space-x-4">
            {user ? (
              <>
                <NotificationBell />
                <div className="flex items-center text-sm">
                  <span className="text-white/90">{user.email}</span>
                  <span className="mx-2 text-white/50">|</span>
                  <span className={`px-2 py-0.5 rounded text-xs font-medium ${
                    user.role === 'admin' 
                      ? 'bg-red-500/20 text-red-100' 
                      : user.role === 'editor'
                      ? 'bg-yellow-500/20 text-yellow-100'
                      : 'bg-green-500/20 text-green-100'
                  }`}>
                    {user.role === 'admin' 
                      ? 'Admin' 
                      : user.role === 'editor'
                      ? 'Editör'
                      : 'Kullanıcı'}
                  </span>
                </div>
                {user.role === 'admin' && (
                  <Link
                    to="/admin"
                    replace={true}
                    className="text-white font-medium relative group"
                  >
                    <span>Admin Panel</span>
                    <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-red-500 via-pink-500 to-purple-500 group-hover:w-full transition-all duration-300"></span>
                  </Link>
                )}
                {user.role === 'editor' && (
                  <Link
                    to="/editor"
                    className="text-white font-medium relative group"
                  >
                    <span>Editör Panel</span>
                    <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-yellow-500 via-amber-500 to-orange-500 group-hover:w-full transition-all duration-300"></span>
                  </Link>
                )}
                <button
                  onClick={handleLogout}
                  className="relative px-4 py-1.5 overflow-hidden rounded group bg-gradient-to-r from-red-500 to-pink-500"
                >
                  <span className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-red-600 to-pink-600 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                  <span className="relative text-sm font-medium text-white">Çıkış</span>
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="relative px-4 py-1.5 overflow-hidden rounded group bg-gradient-to-r from-blue-500 to-indigo-500"
                >
                  <span className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-blue-600 to-indigo-600 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                  <span className="relative text-sm font-medium text-white">GİRİŞ YAP</span>
                </Link>
                <Link
                  to="/register"
                  className="relative px-4 py-1.5 overflow-hidden rounded group bg-gradient-to-r from-red-500 to-pink-500"
                >
                  <span className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-red-600 to-pink-600 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                  <span className="relative text-sm font-medium text-white">KAYIT OL</span>
                </Link>
              </>
            )}
          </div>

          {/* Mobil Menü Butonu */}
          <button onClick={toggleMenu} className="lg:hidden text-2xl focus:outline-none">
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        {/* Mobil Menü */}
        <div className={`lg:hidden ${isMenuOpen ? 'block' : 'hidden'} pt-2 pb-4`}>
          <div className="flex flex-col space-y-2">
            <Link to="/blog" className="hover:bg-blue-700 px-4 py-2 rounded">Blog</Link>
            <Link to="/automation" className="hover:bg-blue-700 px-4 py-2 rounded">Otomasyonlar</Link>
            <Link to="/qa" className="hover:bg-blue-700 px-4 py-2 rounded">Soru & Cevap</Link>
            {user && (
              <>
                <Link to="/requests/new" className="hover:bg-blue-700 px-4 py-2 rounded flex items-center">
                  <FaEnvelope className="mr-2" />
                  Özel İstek
                </Link>
                <Link to="/requests" className="hover:bg-blue-700 px-4 py-2 rounded">İsteklerim</Link>
              </>
            )}
            {!user ? (
              <>
                <Link to="/login" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
                  Giriş Yap
                </Link>
                <Link to="/register" className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">
                  Kayıt Ol
                </Link>
              </>
            ) : (
              <>
                {user.role === 'admin' && (
                  <Link to="/admin" className="hover:bg-blue-700 px-4 py-2 rounded">
                    Admin Panel
                  </Link>
                )}
                {user.role === 'editor' && (
                  <Link to="/editor" className="hover:bg-blue-700 px-4 py-2 rounded">
                    Editör Panel
                  </Link>
                )}
                <div className="px-4 py-2">
                  <span className="block text-sm">{user.email}</span>
                  {user.role && (
                    <span className={`inline-block mt-1 px-2 py-1 rounded-full text-xs ${
                      user.role === 'admin' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'
                    }`}>
                      {user.role === 'admin' ? 'Admin' : 'Editör'}
                    </span>
                  )}
                </div>
                <button
                  onClick={handleLogout}
                  className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 mx-4"
                >
                  Çıkış
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 